export const LoginLayout = ({ title, errorMessage, children }) => {
  const convertError = (err) => {
    const num = err.split("validation error").length
    const mess = num > 1 ? "Username can't contain whitespaces" : err
    return mess;
  }

  return (
    <div className="relative min-h-screen flex justify-center items-center bg-muted px-4 py-8 overflow-hidden">
      {/* Ambient map background — mirrors the marketing site hero treatment */}
      <div
        aria-hidden="true"
        className="absolute inset-0 overflow-hidden pointer-events-none"
      >
        <div
          className="absolute inset-0 bg-center bg-cover opacity-65 dark:opacity-40 dark:invert"
          style={{
            backgroundImage: "url('/image/dublin-map-grey.png')",
            maskImage:
              'radial-gradient(ellipse 80% 75% at 50% 45%, rgba(0,0,0,1) 0%, rgba(0,0,0,0.75) 55%, transparent 95%)',
            WebkitMaskImage:
              'radial-gradient(ellipse 80% 75% at 50% 45%, rgba(0,0,0,1) 0%, rgba(0,0,0,0.75) 55%, transparent 95%)',
          }}
        />
      </div>
      <div className="relative w-full max-w-[400px]">
        <div className="bg-card border border-border rounded-xl shadow-sm">
          <div className="px-8 pt-8 pb-2">
            <div className="flex items-center gap-2.5 mb-6">
              <img
                src='/image/logo.svg'
                alt=""
                className="w-8 h-8 brightness-0 dark:invert"
              />
              <span className="text-sm font-semibold leading-tight text-foreground tracking-tight">
                Central
                <br />
                Valuations
              </span>
            </div>
            <h2 className="text-lg font-medium text-foreground tracking-tight">
              {title}
            </h2>
          </div>
          {errorMessage && (
            <div className="text-destructive px-8 pt-3 text-sm">
              <p>{convertError(errorMessage)}</p>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}